{
  "version": 1,
  "asset_id": "1fd5756a-be56-4744-b107-fa3950b894c9",
  "project_id": "2e05451c-9ac5-4503-b5ea-624bd8d09e1e",
  "url": "/__l5e/assets-v1/1fd5756a-be56-4744-b107-fa3950b894c9/h2j-logo-cropped.png",
  "r2_key": "a/v1/2e05451c-9ac5-4503-b5ea-624bd8d09e1e/1fd5756a-be56-4744-b107-fa3950b894c9/h2j-logo-cropped.png",
  "original_filename": "h2j-logo-cropped.png",
  "size": 8525,
  "content_type": "image/png",
  "created_at": "2026-10-02T20:02:58Z"
}
